import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../../core/services/data.service';

@Component({
  selector: 'app-layout-login',
  templateUrl: './layout-login.component.html',
  styleUrls: ['./layout-login.component.scss']
})
export class LayoutLoginComponent implements OnInit {
  isLoading = true;

  constructor(private dataService: DataService) {
  }

  ngOnInit(): void {
    this.dataService.loading$.subscribe(loading => {
      this.isLoading = loading;
    });
  }
}
